module.exports = __webpack_public_path__ + "img/findSchool.0ca127ca.png";